import * as Yup from 'yup';
import { TFunction } from 'i18next';
import { getTranslationValidationHandling } from 'Hooks/query-hooks/helper';
import { actionsSchema } from 'Components/AddRulePage/schema';

export const simpleRuleValidationSchema = (t: TFunction) => {
    const validationT = getTranslationValidationHandling(t);
    const status = t('Status');
    return Yup.object({
        active: Yup.boolean().required(validationT('required', { field: status })),
        actions: actionsSchema(t, validationT)
    });
};
